/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_PlayInputs */

const th_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชมถ่ายทอดสด`)
};

const en_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch live`)
};

const ja_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブを再生`)
};

const zh_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观看直播`)
};

const es_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver en directo`)
};

const pt_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistir ao vivo`)
};

const id_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonton langsung`)
};

const fr_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regarder en direct`)
};

const tl_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manood nang live`)
};

const vi_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem trực tiếp`)
};

const ko_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간 보기`)
};

const de_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live ansehen`)
};

const ru_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть эфир`)
};

const tr_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı izle`)
};

const it_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda in diretta`)
};

const pl_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oglądaj na żywo`)
};

const uk_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивитися ефір`)
};

const hi_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव देखें`)
};

const ar_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المشاهدة المباشرة`)
};

const ms_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonton langsung`)
};

const bn_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরাসরি দেখুন`)
};

const zh_tw2_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觀看直播`)
};

const zh_hk2_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觀看直播`)
};

const ur_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ راست دیکھیں`)
};

const fa_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تماشای زنده`)
};

const sw_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tazama moja kwa moja`)
};

const nl_video_play = /** @type {(inputs: Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live kijken`)
};

/**
* | output |
* | --- |
* | "Watch live" |
*
* @param {Video_PlayInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_play = /** @type {((inputs?: Video_PlayInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_PlayInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_play(inputs)
	if (locale === "ja") return ja_video_play(inputs)
	if (locale === "zh") return zh_video_play(inputs)
	if (locale === "es") return es_video_play(inputs)
	if (locale === "pt") return pt_video_play(inputs)
	if (locale === "id") return id_video_play(inputs)
	if (locale === "fr") return fr_video_play(inputs)
	if (locale === "tl") return tl_video_play(inputs)
	if (locale === "vi") return vi_video_play(inputs)
	if (locale === "ko") return ko_video_play(inputs)
	if (locale === "de") return de_video_play(inputs)
	if (locale === "ru") return ru_video_play(inputs)
	if (locale === "tr") return tr_video_play(inputs)
	if (locale === "it") return it_video_play(inputs)
	if (locale === "pl") return pl_video_play(inputs)
	if (locale === "uk") return uk_video_play(inputs)
	if (locale === "hi") return hi_video_play(inputs)
	if (locale === "ar") return ar_video_play(inputs)
	if (locale === "ms") return ms_video_play(inputs)
	if (locale === "bn") return bn_video_play(inputs)
	if (locale === "zh-TW") return zh_tw2_video_play(inputs)
	if (locale === "zh-HK") return zh_hk2_video_play(inputs)
	if (locale === "ur") return ur_video_play(inputs)
	if (locale === "fa") return fa_video_play(inputs)
	if (locale === "sw") return sw_video_play(inputs)
	if (locale === "nl") return nl_video_play(inputs)
	return en_video_play(inputs)
});